import { Notify } from 'application/Shared/Helpers';
import Logger from 'application/Shared/Utils/Debug';
import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useUploadManifest = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const uploadManifest = async (file: File) => {
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append('manifest', file);

        try {
            await axios.put('/workato/uploadManifest', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            Notify.s(t('Admin.Manifests.upload.success'));
        } catch (error) {
            if (axios.isAxiosError(error)) {
                setError(
                    error.response?.data?.message ||
                        'Error uploading manifest. Please try again.'
                );
            } else {
                setError('An unexpected error occurred. Please try again.');
            }
            Logger.error('Error uploading manifest:', error);
            Notify.e(t('Admin.Manifests.upload.error'));
        } finally {
            setLoading(false);
        }
    };

    return {
        error,
        loading,
        uploadManifest
    };
};
